<template>
  <vue-select
    style="width: 100%"
    :value="value"
    @search="getOptions"
    id="kategory"
    :options="items"
    label="label"
    class="select-x"
    placeholder="Pilih Kategori"
    @input="changed"
  ></vue-select>
</template>

<script>
import { HTTPAUTH } from "../lib/httplib";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    VueSelect,
  },
  name: "CategorySelector",
  data() {
    return {
      items: [],
    };
  },
  props: ["value"],
  created() {
    this.init("");
  },
  methods: {
    init(q) {
      HTTPAUTH.get(`/api/admin/product-category?q=${q}`).then((res) => {
        this.items = res.data.data;
      });
    },
    getOptions(search, loading) {
      loading(true);
      this.init(search);
      loading(false);
    },
    changed(evt) {
      this.$emit("input", evt);
    },
  },
};
</script>

<style scoped>
</style>
